import { Link } from "react-router-dom";
import { genElNumber } from "@components/utils/EditorDialogElementGenerator";
import FieldTextarea from "./field-textarea";
import SectionCard from "./section-card";
import SignatureRow from "./signature-row";

const signers = [
  { name: "diketahui_unit", label: "Diketahui", title: "Kepala Unit" },
  { name: "diterima", label: "Diterima", title: "Penerima BBM" },
];

// IV. Penerimaan (Unit)
const SectionPenerimaan = (props) => {
  const { data, setData, error, stage, saving, onSave, signProps, cardProps } = props;

  const disabled = stage !== "active";

  return (
    <SectionCard
      {...cardProps}
      code="IV"
      title="Penerimaan"
      role="Unit"
      stage={stage}
      saving={saving}
      onSave={onSave}
      signatures={
        <SignatureRow
          signers={signers}
          data={data}
          canSign={stage === "active" && !!data.id}
          {...signProps}
        />
      }
    >
      <div className="col-start-start w-100 gap-1">
        <label className="font-bold text-sm text-slate-500">
          Jumlah Disetujui (Liter)
        </label>
        <span className="font-bold text-slate-600">
          {Number(data.jumlah_disetujui ?? 0).toLocaleString("id-ID")}
        </span>
      </div>
      {genElNumber({
        field: "jumlah_diterima",
        name: "Jumlah Diterima (Liter)",
        data,
        setData,
        error,
        disabled,
        showButtons: false,
        max_fraction_digits: 2,
      })}
      <div className="w-100 md:col-span-2">
        <FieldTextarea
          field="keterangan_penerimaan"
          name="Keterangan Penerimaan"
          data={data}
          setData={setData}
          error={error}
          disabled={disabled}
        />
      </div>
      <div className="col-start-start w-100 gap-1 md:col-span-2">
        <label className="font-bold text-sm text-slate-500">Kartu Stok</label>
        {data.is_sudah_catat_kartu_stok > 0 ? (
          <div className="col-start-start w-full gap-1 rounded-md bg-emerald-50 px-3 py-2">
            <div className="row-start-start gap-2 text-emerald-600">
              <i className="pi pi-check-circle mt-0.5" />
              <span className="text-sm font-semibold">
                Sudah tercatat otomatis sebagai mutasi masuk.
              </span>
            </div>
            {/* opens the sheet of this department + jenis minyak, in the month of the receipt */}
            <Link
              to="/transaksi/kartu-stok-minyak"
              state={{
                kartuStok: {
                  department_id: data.department_id,
                  data_department: {
                    id: data.department_id,
                    ...data.data_department,
                  },
                  jenis_minyak_id: data.jenis_minyak_id,
                  data_jenis_minyak: {
                    id: data.jenis_minyak_id,
                    ...data.data_jenis_minyak,
                  },
                  tanggal: data.verif_diterima_datetime ?? data.tanggal,
                },
              }}
              className="pl-6 text-sm font-semibold text-indigo-500"
            >
              Lihat kartu stok <i className="pi pi-arrow-right text-xs" />
            </Link>
          </div>
        ) : (
          <div className="row-start-start w-full gap-2 rounded-md bg-slate-50 px-3 py-2 text-slate-400">
            <i className="pi pi-info-circle mt-0.5" />
            <span className="text-sm">
              Setelah diverifikasi "Diterima", jumlah diterima otomatis masuk ke
              Kartu Stok Minyak.
            </span>
          </div>
        )}
      </div>
    </SectionCard>
  );
};

export default SectionPenerimaan;
